'use client';

import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '@/lib/utils';

import Text from '@/components/atoms/text';

const Progress = React.forwardRef(({ className, value, pageName, ...props }, ref) => (
	<div className={cn('flex justify-center shadow-drop-shadow', className)}>
		<div className="flex flex-col w-full gap-4 p-6 md:py-11 md:px-8 xl:px-eis-72 max-w-eis-1440">
			<ProgressPrimitive.Root ref={ref} className={cn('relative h-2 w-full overflow-hidden rounded-full bg-eis-light-blue-1', className)} {...props}>
				<ProgressPrimitive.Indicator
					className="flex-1 h-full transition-all rounded-full bg-gradient-to-r from-corporateBlueBright to-corporateBlueBrightLight"
					style={{ width: `${value}%` }}
				/>
			</ProgressPrimitive.Root>

			{pageName && (
				<Text type="p" variant="bold" className="self-end hidden md:block text-formOutlineDark">
					{pageName}
				</Text>
			)}
		</div>
	</div>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
